import PageHeadline from '../../components/molecules/headlines/PageHeadline'
import DecorationSubTitle from '../../components/atoms/decoration/DecorationSubTitle'
import DecorationSubTitleSmall from '../../components/atoms/decoration/DecorationSubTitleSmall'

export default {
  components: { PageHeadline, DecorationSubTitle, DecorationSubTitleSmall }
}
